/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceScheduleModel } from '../../models/service-schedule-model';

export interface AnonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params {
  healthCareServiceFhirId: string;
  locationFhirId: string;
  specialityFhirId: string;
}

export function anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet(http: HttpClient, rootUrl: string, params: AnonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<ServiceScheduleModel>> {
  const rb = new RequestBuilder(rootUrl, anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('healthCareServiceFhirId', params.healthCareServiceFhirId, {});
    rb.path('locationFhirId', params.locationFhirId, {});
    rb.path('specialityFhirId', params.specialityFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<ServiceScheduleModel>;
    })
  );
}

anonymousServiceHoursOfOperationHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet.PATH = '/Anonymous/ServiceHoursOfOperation/{healthCareServiceFhirId}/{locationFhirId}/{specialityFhirId}';
